<p-dialog [(visible)]="visible" [style]="{width: widthSize}" [maximizable]="true">
    <ng-template *ngIf="showNorthernZoneCheckbox" pTemplate="header">
        <div class="northern-zone-header">
            <p-checkbox [binary]="true" [(ngModel)]="selectAllNorthernZone"
                [disabled]="isNorthernZoneCheckboxDisabled"
                (onChange)="onToggleNorthernZone($event)"
                inputId="selectAllNorthernZone"></p-checkbox>
            <label for="selectAllNorthernZone">Select all Northern zone locations</label>
        </div>
    </ng-template>
    <app-grid #grid [columnDefs]="columsDef" [rowData]="displayedRowData" [rowSelection]="'multiple'"
        [isProjectOwnershipValid]="isProjectOwnershipValid" [suppressRowClickSelection]="true"
        (calendarSelectionChangeEvent)="onCalendarSelectionChanged($event)" [pagination]="false"
        (dropDownSelectionChangeEvent)="onDropDownSelectionChanged($event)"
        (onInputNumberChanged)="onJulianDayChanged($event)"
        (onCheckboxSelectedEvent)="onCheckboxSelectionChanged($event)"
        (onFirstDataRenderedEvent)="onGridFirstDataRendered()"
        (onRowSelectedEmit)="onRowSelectionChanged()"
        (onChangeAllMitigationSelectionEvent)="onCheckboxAllSelectionChanged($event)"></app-grid>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="closeDialog()" label="Save" [disabled]="!isProjectOwnershipValid || pendingBbchRequests > 0"
            pAutoFocus [autofocus]="true"></p-button>
    </ng-template>
</p-dialog>